<template>
  <div v-bind:class="`${amplifyUI.formSection} sign-in-section ${errored ? 'errored' : 'normal'}`" v-bind:data-test="auth.signIn.section">
    <div v-bind:class="amplifyUI.sectionHeader" v-bind:data-test="auth.signIn.headerSection">{{options.header}}</div>
    <div v-bind:class="amplifyUI.sectionBody" v-bind:data-test="auth.signIn.bodySection">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel" :data-test="'username-label'" >{{$Amplify.I18n.get('Username')}}</div>
        <input spellcheck="false" v-bind:class="amplifyUI.input" :data-test="'username-input'"  v-model="options.username" :placeholder="$Amplify.I18n.get('Enter your username')" input="updateRemember" autofocus v-on:keyup.enter="signIn" v-bind:data-test="auth.signIn.usernameInput" />
      </div>
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel" :data-test="'password-label'">{{$Amplify.I18n.get('Password')}}</div>
        <input spellcheck="false"  v-bind:class="amplifyUI.input" :data-test="'username-input'"  v-model="password" type="password" :placeholder="$Amplify.I18n.get('Enter your password')" v-on:keyup.enter="signIn" v-bind:data-test="auth.signIn.passwordInput" />
      </div>
    </div>
<el-switch  size="small" :width="32" v-tooltip="`Switching this <b>on</b> will stop 2FA prompts for<br/>Multifactor Authentication<br/>(if enabled)`" style="text-align:center;" id="remember" class="signIn remember" :disabled="false" v-model="remember" active-text="trust this device" inactive-text="" v-on:change="rememberDevice()"/>
    <div v-bind:class="amplifyUI.sectionFooter" v-bind:data-test="auth.signIn.footerSection">
      <span v-bind:class="`${amplifyUI.sectionFooterSecondaryContent} noaccount`" v-if="options.isSignUpDisplayed">
        {{$Amplify.I18n.get('No account? ')}}
        <a v-bind:class="amplifyUI.a" v-on:click="signUp" v-bind:data-test="auth.signIn.createAccountLink">{{$Amplify.I18n.get('Create account')}}</a>
      </span>
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button :disabled="!(password && password.length >= 8 && options && options.username)" v-bind:class="amplifyUI.button" v-on:click="signIn" v-bind:data-test="auth.signIn.signInButton">
          <geno-spinner :loading="flow" :text="$Amplify.I18n.get('Sign In')" :size="32"></geno-spinner>
          </button>
      </span>
        <span v-bind:class="`${amplifyUI.hint} forgot-password`" :data-test="'forgot-password'">
          <a v-bind:class="amplifyUI.a" v-on:click="forgot" v-bind:data-test="auth.signIn.forgotPasswordLink">Forgot Password?</a>
        </span>
    </div>
    <div class="error" v-if="false" v-bind:data-test="auth.signIn.signInError">
      {{ error }}
    </div>
  </div>
</template>

<script>
import AmplifyEventBus from '../../events/AmplifyEventBus';
import * as AmplifyUI from '@aws-amplify/ui';
import { auth } from '../../assets/data-test-attributes';
import { Auth } from 'aws-amplify'
import {
    Switch
} from 'element-ui'
    const version = require('aws-amplify/package.json').version;
        console.log('AWS Amplify version:', version);

export default {
  name: 'SignIn',
  props: ['signInConfig'],
  data () {
    return {
        flow: false,
        errored: false,
        remember: false,
        password: '',
        error: '',
        amplifyUI: AmplifyUI,
        auth,
        logger: {},
    }
  },
  computed: {
        user: {
            get: function() {
                return this.$store.getters.get('mfaUser');
            },
            set: function(value) {
                this.$store.commit('change', {
                    mfaUser: value
                })
            },
        },
    options() {
      const defaults = {
        header: 'or, use your Genoplot account',
        username: '',
        isSignUpDisplayed: true
      }
      return Object.assign(defaults, this.signInConfig || {})
    }
  },
  created() {
  this.user = null;
  },
  mounted() {
    console.log('mounted signIn')
      AmplifyEventBus.$on('appEvents', this.appEvents)
      AmplifyEventBus.$emit('loginErrors', { source: 'signIn', error: this.error})
    this.logger = new this.$Amplify.Logger(this.$options.name);
    this.remember = localStorage.getItem('genoplot:remember-device') ? true : false
        if (localStorage.getItem(`lastEvent`)) {
            try {
                let now = Date.now()
                let event = localStorage.getItem(`lastEvent`);
                event = JSON.parse(event);
                event.remove = true
                if (event.timestamp && (now - event.timestamp) <= 10000) {
                    this.appEvents(event);
                } else {
                localStorage.removeItem(`lastEvent`)
                console.log('Expired event')
                }
            } catch (err) {
                console.log(err)
                localStorage.removeItem(`lastEvent`)
            }
        }
  },
  beforeDestroy() {
      AmplifyEventBus.$off('appEvents', this.appEvents)
  },
  methods: {
        appEvents: function(info) {
            if (typeof(info) === 'object' && (info.component === 'signInModal')) {
                if (this[info.exec]) {
                    this[info.exec](info.params)
                }
                if ( info.remove ) {
                localStorage.removeItem(`lastEvent`)
                console.log('removed Event', info)
                }
            }
        },
    rememberDevice: function(evt) {
        if ( this.remember ) {
        localStorage.setItem('genoplot:remember-device', 'true')
        } else {
        localStorage.removeItem('genoplot:remember-device')
        }
    },
    signIn: async function(event) {
      sessionStorage.clear()
      this.errored = false;
      let meta;
      try {
      meta = sessionStorage.getItem('devicemeta')
      meta = meta ? meta : JSON.stringify({})
      //delete meta.ua;
      //delete meta.platform;
      }
      catch(err) {
      console.log('meta parsing', err)
      }
      AmplifyEventBus.$emit('loginErrors', { source: 'signIn', error: ''})
      this.flow = true
      const that = this
      this.$Amplify.Auth.signIn(this.options.username, this.password, {clientMetadata: meta})
        .then(async data => {
            this.flow = false
          this.logger.info('sign in success');
          if (data.challengeName === 'SMS_MFA' || data.challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.user = data;
            AmplifyEventBus.$emit('localUser', data);
            AmplifyEventBus.$emit('authState', 'confirmSignIn');
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.user = data;
            AmplifyEventBus.$emit('localUser', data);
            AmplifyEventBus.$emit('authState', 'requireNewPassword');
          } else if (data.challengeName === 'MFA_SETUP') {
            this.user = data;
            AmplifyEventBus.$emit('localUser', data);
            //let user = await this.$Amplify.Auth.currentAuthenticatedUser()
            return AmplifyEventBus.$emit('authState', 'setMfa');
          } else {
            this.user = data;
            //return AmplifyEventBus.$emit('authState', 'setMfa');
            return AmplifyEventBus.$emit('authState', 'signedIn')
          }
        })
        .catch((e) => {
          console.log('signedInerror', e)
          this.flow = false
          if (e.message && e.message === 'User is disabled.'){
            console.log('disabled');
            AmplifyEventBus.$emit('appEvents', {
                                    exec: 'showToast',
                                    component: 'nav',
                                    params: {
                                        className: 'toastDiaabledUser toastError',
                                        message: 'Your account has been diaabled as a precaution<br>due to unusual activity on your account.<br><br>Please contact us if you feel this action was erroneous.<br>',
                                        toast: true,
                                        position: 'top-center'
                                    }
                                })
            this.setError(e);
          } else if ((e.code && e.code === 'UserNotConfirmedException') || ( e.code && e.code == "UserLambdaValidationException" && e.message == "PreAuthentication failed with error 811.")){
            AmplifyEventBus.$emit('localUser', {username: this.options.username})
            AmplifyEventBus.$emit('authState', 'confirmSignIn')
          } else {
            if ( e.message == 'Request not allowed due to WAF block.' ) e.message = 'Request not allowed due to Firewall rules.\n\nIf you are using a VPN, you may browse the website, however login via a VPN is not allowed'
            this.setError(e);
          }
        });
    },
    forgot: function() {
      AmplifyEventBus.$emit('authState', 'forgotPassword')
    },
    signUp: function() {
      AmplifyEventBus.$emit('authState', 'signUp')
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.errored = true;
      AmplifyEventBus.$emit('loginErrors', { source: 'signIn', error: this.error})
      this.logger.error(this.error)
    }
  },
  components: {
  [Switch.name]: Switch,
  }
}
</script>
